export default {
  process: {
    step1: '货架设置',
    step2: '元素布局',
    step3: '玩法设置',
    next: '下一步',
    previous: '上一步',
    finish: '完成',
  },
  step1: {
    setting1: {
      title: '货架行列',
      rowCol: '行列数',
      row: '行',
      col: '列',
      reverse: '[行列数]横竖屏行列数倒转',
      reverseTip:
        '勾选后横竖屏格子按照如下序号摆放：<br/>竖屏格子序号为<br/>1 2<br/>3 4<br/>5 6<br/>则横屏格子序号为<br/>1 3 5<br/>2 4 6 ',
      layout: '排布形式',
      align: '行列对齐',
      colDisLocation: '列错位',
      rowDisLocation: '行错位',
    },
    setting2: {
      title: '货架尺寸',
      gridSize: '格子尺寸',
      followGridImg: '按格子图片',
      wholeSize: '整体尺寸',
      gridImg: '格子图片',
      gridImgUpload: '请上传格子图片',
      shelvesImg: '货柜图片',
      shelvesImgUpload: '请上传货柜图片',
      shelvesPivot: '货柜锚点',
      shelvesPivotDesc: '绿点为网格<br/>可移动绿点调整货柜出现位置',
    },
  },
  step2: {
    setting1: {
      title: '单个格子设置',
      goodsNum: '格子内元素数量',
      padding: '内间距',
      left: '左',
      right: '右',
      up: '上',
      down: '下',
    },
    setting2: {
      goods: '元素',
      selectGoods: '请选择元素图片',
      error: '当前数量不满足全部消除',
    },
    setting3: {
      title: '高级设置',
      weight: '按权重排版',
      highlight: '元素外发光',
      blur: '模糊',
      preview: '预览样式',
      closePreview: '关闭预览',
      apply: '应用',
      weightErrorTip: '权重总和需等于100%，请重新配置',
    },
  },
  step3: {
    setting1: {
      title: '特定玩法格子',
      addBtn: '添加特定玩法格子',
      grid: '格子',
    },
    setting2: {
      title: '消除后格子状态',
      reserve: '格子保留',
      reserveEff: '保留效果',
      close: '关闭',
      noClose: '不关闭',
      closeImage: '关闭图片',
      uploadCloseImage: '请上传关闭图片',
      closeImageTip:
        '选中图片后，可在画布中选择默认关闭的格子，这些格子将在游戏之初就呈现关闭状态。',
      remove: '格子消除',
      removeEff: '掉落玩法',
      fall: '掉落',
      noFall: '不掉落',
    },
    setting3: {
      title: '前台默认值',
      remove: '消除',
      noRemove: '不消除',
      closeOrNot: '是否关闭',
      fallTitle: '上方格子是否掉落',
      fall: '掉落',
      noFall: '不掉落',
    },
  },
}
